import { AppSetting } from '../AppSetting';
import { BaseWebApiDAO } from './BaseWebApiDAO';
import { BaseService } from '../Service/BaseService';
import { AppSettingApi } from '../AppSettingApi';
import {UserDTOInterface} from '../DTO/UserDTOInterface';



/**
 * UserDAO
 * 認証系DAO
 */
export class UserDAO extends BaseWebApiDAO {

	// コンストラクタ
	constructor(svc: BaseService) {
		super(svc);
	}

	/**
	 * getUserInfo
	 * ユーザー情報の取得
	 * @returns ユーザー情報
	 */
	public async getUserInfo() {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token
		};

		const ret = await this.postRequest(AppSettingApi.USER_INFO_GET, request);
		return ret;

	}


	/**
	 * ユーザー情報の登録を行う
	 * @param data 登録を行うユーザー情報
	 * @returns 登録されたユーザー情報
	 */
	public async saveUserInfo(data: any, id: string) {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			identifier: id,
			lastname: data.value.lastname,
			firstname: data.value.firstname,
			lastname_kana: data.value.kanalastname,
			firstname_kana: data.value.kanafirstname,
			middlename: data.value.middlename,
			gender: data.value.gender,
			birthday: data.value.birthday,
			tel_number: data.value.tel,
			device_type: data.value.deviceType,
			post_code: data.value.postCode,
			prefecture: data.value.prefecture,
			city: data.value.city,
			address: data.value.address,
			building: data.value.building,
			to_name: data.value.toName,
			email: data.value.email,
			password: data.value.password
		};

		const ret = await this.postRequest(AppSettingApi.USER_INFO_SAVE, request);
		return ret;

	}

	/**
	 * saveUserMedicalInfo
	 * 診察券番号（カルテ番号）、クリニックタイプを登録
	 * @param data 診察券番号（カルテ番号）、クリニックタイプ
	 */
	public async saveUserMedicalInfo(data: any) {

		this.log(data);

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token,
			medical_record_number: data.medicalRecord.wellnestClinic.medicalRecordNumber.toString(),
			medical_record_type: 'WELLNEST-CLINIC'	// これは一旦固定
		};

		const ret = await this.postRequest(AppSettingApi.USER_INFO_MED_SAVE, request);
		return ret;

	}

	/**
	 * updateUserInfo
	 * ユーザー情報の更新
	 * @param data ユーザー情報
	 */
	public async updateUserInfo(data: any) {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token,
			lastname: data.lastname,
			firstname: data.firstname,
			lastname_kana: data.lastnameKana,
			firstname_kana: data.firstnameKana,
			middlename: data.middlename,
			gender: data.gender,
			birthday: data.birthday,
			tel_number: data.telNumber,
			device_type: data.deviceType,
			post_code: data.postCode,
			prefecture: data.prefecture,
			city: data.city,
			address: data.address,
			building: data.building,
			to_name: data.toName,
			email: data.email,
		};

		const ret = await this.postRequest(AppSettingApi.USER_INGO_UPDATE, request);
		return ret;
	}


	/**
	 * オンライン診療に必要な情報の更新
	 * @param data
	 */
	public async updateOnlineMedicalData(data: UserDTOInterface): Promise<any> {
		this.log('UserDAO::updateOnlineMedicalData()');
		const request = {
			t: this.token,
			device_type: data.deviceType,
			tel_number: data.telNumber,
		};

		this.log(request);
		const ret = await this.postRequest(AppSettingApi.USER_INFO_ONLINE_MEDICAL_DATA_UPDATE, request);
		return ret;
	}

	/**
	 * getLineLinkStatus
	 * Lineとの連携状態を取得する
	 * @returns true: 連携済み/false: 未連携
	 */
	public async getLineLinkStatus() {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token
		};

		const ret = await this.postRequest(AppSettingApi.USER_LINE_STATUS, request);
		return ret;

	}

	/**
	 * unlinkLineLink
	 * ライン連携解除設定
	 */
	public async unlinkLineLink() {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token
		};

		const ret = await this.postRequest(AppSettingApi.USER_LINE_UNLINK, request);
		return ret;

	}


}

